import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "react-chat-widget/lib/styles.css";
import {
  Avatar,
  TextField,
  Tooltip,
  Modal,
  Box,
  Switch,
  FormControlLabel,
  Checkbox,
  Zoom,
  Chip,
  Button,
  ListItem,
  ListItemButton,
  List,
  ListItemIcon,
  ListItemText,
  Divider,
  Popover,
  IconButton,
  FormControl,
  Drawer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  Paper,
  TableContainer,
} from "@mui/material";
import * as XLSX from "xlsx";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import MainPage from "../_layout/main.page";
import SpeakerNotesOutlinedIcon from "@mui/icons-material/SpeakerNotesOutlined";
import aiicon from "../assets/images/logo-icon.png";
import VideoCameraBackOutlinedIcon from "@mui/icons-material/VideoCameraBackOutlined";
import { styled } from "@mui/material/styles";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import PhotoFilterOutlinedIcon from "@mui/icons-material/PhotoFilterOutlined";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import DynamicFeedOutlinedIcon from "@mui/icons-material/DynamicFeedOutlined";
import AddIcon from "@mui/icons-material/Add";
import PlayCircleFilledOutlinedIcon from "@mui/icons-material/PlayCircleFilledOutlined";
import ChatForm from "../components/chatform";
import ChatContentLoader from "../components/loader/chatcontent_loader";
import SourceLoader from "../components/loader/source_loader";
import GenerateImageLoader from "../components/loader/GenerateImageLoader";
import ColorLensOutlinedIcon from "@mui/icons-material/ColorLensOutlined";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ArchitectureOutlinedIcon from "@mui/icons-material/ArchitectureOutlined";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import PageLoader from "../components/page-loader";
import { motion } from "framer-motion";
import ReactReadMoreReadLess from "react-read-more-read-less";
import BrowserImageLoader from "../components/loader/browserimage_loader";
import ReactMarkdown from "react-markdown";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import { v4 as uuidv4 } from "uuid";
import host from "../host";
import MessageSnackbar from "../_layout/elements/snackbar";
import { LightgalleryItem } from "react-lightgallery";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import MenuIcon from "@mui/icons-material/Menu";
import ShareChat from "../components/share-chat";
import ImageComponent from "../components/image-component";
import brainicon from "../assets/images/brain.png";
import { marked } from "marked";
import Mermaid from "../components/mermaid";
import MermaidEditor from "../components/mermaid-editor";
import CircularProgressloader from "../components/loader/CircularProgress";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ZoomOutOutlinedIcon from "@mui/icons-material/ZoomOutOutlined";
import ZoomInOutlinedIcon from "@mui/icons-material/ZoomInOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
// eslint-disable-next-line import/no-webpack-loader-syntax
// import css from "raw-loader!../assets/css/style.css";
// import Ej2ReactPdf from '../components/pdf_view/ej2-react-pdfviewer';
const label = { inputProps: { "aria-label": "Checkbox demo" } };
export const BrowserHomePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = localStorage.getItem("login") === "true";

  const [title, setTitle] = useState(localStorage.getItem("chatTitle") || "Untitled");
  const [isEditing, setIsEditing] = useState(false);
  const [browserMode, setBrowserMode] = useState(true);
  useEffect(() => {
    localStorage.setItem("chatTitle", title);
  }, [title]);
  const handleTitleClick = () => {
    setIsEditing(true);
  };
  const handleInputChange = (e) => {
    setTitle(e.target.value);
  };
  const handleInputBlur = () => {
    setIsEditing(false);
  };
  const handleInputKeyPress = (e) => {
    if (e.key === "Enter") {
      setIsEditing(false);
    }
  };

  //Time and date start
  function getTimeDifference(chatTime) {
    if (chatTime === 0) {
      return "Just now";
    }
    const now = new Date();
    const timeDifference = now - new Date(chatTime);
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return `${days} day${days > 1 ? "s" : ""} ago`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    } else if (minutes > 0) {
      return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    } else {
      return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
    }
  }
  //Time and date end

  //this below function for share chat start//
  const [opensharechat, setOpensharechat] = React.useState(false);
  const activesharechat = () => setOpensharechat(true);
  const handleClosesharechat = () => setOpensharechat(false);
  //this below function for share chat end//

  //graph functionality start
  const [graphLoading, setGraphLoading] = useState(false); // to show loader while graph is loading in stream api
  const [graphData, setGraphData] = useState(""); // to store graph data
  let currentGraphData = "";
  const [isOpengrapg, setIsOpengrapg] = useState(false);
  const [graphKey, setGraphKey] = useState(0);
  const toggleDrawergrapg = (graphData) => {
    setGraphData(graphData);
    setIsOpengrapg(true);
    setGraphKey((prevKey) => prevKey + 1);
  };
  const closeDrawergraph = () => setIsOpengrapg(false);

  const exportToExcel = (headerCells, tableRows) => {
    const data = [
      headerCells,
      ...tableRows.slice(2).map((row) =>
        row
          .split("|")
          .filter((cell) => cell.trim().length > 0)
          .map((cell) => cell.trim())
      ),
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, "table.xlsx");
  };

  const processChatResponse = (chat, index) => {
    if (!chat.rawResponse || !chat.throughHistory) {
      return null;
    }
    if (chat.rawResponse.includes("|") || chat.rawResponse.includes("```marked")) {
      const responseLines = chat.rawResponse.split("\n");
      const tableRows = responseLines.filter((row) => row.trim().length > 0 && row.includes("|"));
      const headerIndex = tableRows.findIndex((row) => /^[-| ]+$/.test(row)) - 1;
      const headerCells =
        tableRows[headerIndex]
          ?.split("|")
          .filter((cell) => cell.trim().length > 0)
          .map((cell) => cell.trim()) || [];

      return (
        <div>
          {tableRows.length > 0 ? (
            <div className="web-table  responce_table ">
              <TableContainer sx={{ maxHeight: 300, textAlign: "center", borderRadius: "10px", overflow: "hidden", overflowY: "auto" }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {headerCells.map((cell, cellIndex) => (
                        <TableCell key={cellIndex}>
                          <ReactMarkdown>{cell}</ReactMarkdown>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableRows.slice(headerIndex + 2).map((row, rowIndex) => (
                      <TableRow key={rowIndex}>
                        {row
                          .split("|")
                          .filter((cell, cellIndex) => cellIndex > 0 && cellIndex < row.split("|").length - 1)
                          .map((cell, cellIndex) => (
                            <TableCell key={cellIndex}>{cell.trim() === "-" ? cell.trim() : <ReactMarkdown>{cell.trim()}</ReactMarkdown>}</TableCell>
                          ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="table_responce_action">
                <div className="table_responce_action_flex">
                  <Tooltip className="blue-tooltip" title="Download Excel Sheet" placement="bottom" arrow>
                    <button type="button" className=" btn btn-default" style={{ padding: "5px 10px", fontSize: "12px" }} onClick={() => exportToExcel(headerCells, tableRows)}>
                      <FileDownloadOutlinedIcon fontSize="small" /> Download Excel
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
          ) : null}
          {responseLines.map((row, rowIndex) => {
            if (graphLoading && (chat.graphData === "" || chat.graphData === null || chat.graphData === undefined)) {
              {
                /* return <CircularProgressloader key={rowIndex} />; */
              }
            } else if (row.includes("```marked") && !graphLoading) {
              return (
                <div className="text-start pt-2 pb-2" key={rowIndex}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => {
                      console.log(chat.graphData);
                      toggleDrawergrapg(chat.graphData);
                    }}
                    style={{
                      background: "#eee",
                      backgroundColor: "#efedf2",
                      border: "1px solid hsla(60, 10%, 83%, .6)",
                      cursor: "pointer",
                    }}
                  >
                    View Graph
                  </button>
                </div>
              );
            }
            return null;
          })}
        </div>
      );
    } else {
      return <ReactMarkdown key={index}>{chat.rawResponse}</ReactMarkdown>;
    }
  };


  //graph functionality ends

  //download chat functionality start
  const handleDownloadChat = async (chatHistory, title) => {
    const element = document.createElement("div");

    // Convert React components into HTML string
    const chatContent = chatHistory.map((chat, index) => {
      const markdownContent = marked(chat.response); // Convert Markdown to HTML

      return `<div class="left_chat_content" key=${index}>
        <div class="chat_message_title">
            <h4 style="font-size: 18px;">${chat.request}</h4>
        </div>

        <div class="answer_wrapper chat_sections">
            <div class="sources_title" style="white-space: nowrap;">
                <div class="sourse-icon">
                    <div class="chat_brain" >
                        <img src=${brainicon} alt="" height=${25}/>
                        ${localStorage.getItem("isKnowledgeChat") === "false" ? `<span>${chat.brain ? chat.brain : "NA"}</span>` : ""}
                    </div>
                </div>
                ${localStorage.getItem("isKnowledgeChat") === "false" ? "<span>/</span>" : ""}
                <h5>Answer</h5>
            </div>
            <div class="answer_body">
                <div class="answer_content">${markdownContent}</div>
            </div>
        </div>
    </div>`;
    });

    // Join the HTML strings and set as innerHTML
    element.innerHTML = chatContent.join("");

    // Inline the CSS
    // const inlined = juice.inlineContent(element.innerHTML, css);

    // Now `inlined` contains your HTML with inlined CSS
    // You can use it to generate your PDF

    const options = {
      margin: 10,
      filename: "invoice.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      pagebreak: { mode: "avoid-all" },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    // html2pdf().from(inlined).set(options).toPdf().save(`${title}.pdf`);
  };
  // download chat functionality end
  /* Popup handling functions start */
  const [opendelete, setOpendelete] = useState(false);
  const activedelet = () => setOpendelete(true);
  const handleClosedelete = () => setOpendelete(false);
  /* Popup handling functions end */

  const [showAll, setShowAll] = useState([]);
  const handleClickShowMore = (index) => {
    setShowAll((prevShowAll) => {
      const newShowAll = [...prevShowAll];
      newShowAll[index] = true;
      return newShowAll;
    });
  };
  //audio listening    function start//
  const [isListening] = useState(false);
  //audio listening    function end//]
  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));
  /*hindi eng  switch function start*/
  const [currentLanguage, setCurrentLanguage] = useState("english");
  const handleLanguageToggle = (index, chatResponse) => {
    setCurrentLanguages((prevLanguages) => {
      const newLanguages = [...prevLanguages];
      newLanguages[index] = newLanguages[index] === "english" ? "hindi" : "english";
      return newLanguages;
    });

    if (!translatedResponses[index]) {
      translateLanguage(index, chatResponse);
    }
  };

  const translateLanguage = (index, text) => {
    setLoading(true);
    let mainquery = `/synthesize/translate`;
    fetch(host.chaturl + mainquery, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify({
        text: text,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setLoading(false);
        if (data) {
          setTranslatedResponses((prevState) => ({
            ...prevState,
            [index]: data.translated_text,
          }));
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  /*hindi eng  switch function end*/
  //this below function for skill suggition start//
  const [copyStatus, setCopyStatus] = useState({});
  const handleClick = (index, message) => {
    // Copying message to clipboard
    navigator.clipboard
      .writeText(message)
      .then(() => {
        setCopyStatus((prevState) => ({
          ...prevState,
          [index]: true,
        }));
      })
      .catch((error) => {
        console.error("Failed to copy:", error);
      });
  };
  //this below function for skill suggition end//
  //generateimage open  function start//
  const [anchorElgenerateimg, setAnchorElgenerateimg] = React.useState(null);
  const [currentMessageId, setCurrentMessageId] = useState(null);
  const [currentRequest, setCurrentRequest] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);

  const handleClickgenerateimg = (event, message_id, request, index) => {
    setAnchorElgenerateimg(event.currentTarget);
    setCurrentMessageId(message_id);
    setCurrentRequest(request);
    setCurrentIndex(index);
  };
  const handleClosegenerateimg = () => {
    setImageGenerateType(4);
    setAnchorElgenerateimg(null);
    setCurrentMessageId(null);
    setCurrentRequest(null);
    setCurrentIndex(null);
  };
  const opengenerateimg = Boolean(anchorElgenerateimg);
  //generateimage open  function end//

  const [showVideo, setShowVideo] = useState([]);
  const handleShowVideo = (index) => {
    setShowVideo((prevShowAll) => {
      const newShowAll = [...prevShowAll];
      newShowAll[index] = !newShowAll[index];
      return newShowAll;
    });
  };

  const [imageGenerateType, setImageGenerateType] = useState(4);
  const [imageGeneratePrompt, setImageGeneratePrompt] = useState("");
  const [generateImageLoading, setGenerateImageLoading] = useState([]);

  const setGenerateLoading = (index, isLoading) => {
    setGenerateImageLoading((prevState) => {
      const newState = [...prevState];
      newState[index] = isLoading;
      return newState;
    });
  };

  const toggleImageGenerateType = (type) => {
    setImageGenerateType((prevType) => (prevType === type ? 4 : type));
  };

  const handleImageGenerate = (message_id, prompt, index) => {
    if (imageGenerateType === 4 && imageGeneratePrompt === "") {
      setSeverity("error");
      setMessage("Either select a type or enter a custom prompt");
      setSnackbar(true);
    } else {
      handleClosegenerateimg();
      setGenerateLoading(index, true);
      let mainquery = `/synthesize/${chatId}/image/${message_id}?prompt=${prompt}`;
      if (imageGenerateType !== null) {
        mainquery += `&prompt_extension=${imageGenerateType}`;
      }
      if (imageGeneratePrompt !== "") {
        mainquery += `&custom_prompt=${imageGeneratePrompt}`;
      }
      fetch(host.chaturl + mainquery, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else if (res.status === 403) {
            dispatch(changeAuth(false, null));
            navigate("/logout");
          } else {
            setGenerateLoading(index, false);
            setSeverity("error");
            setMessage("Something went wrong");
            setSnackbar(true);
          }
        })
        .then((data) => {
          if (data) {
            setGenerateLoading(index, false);
            setChatHistory((prevChatHistory) => {
              const updatedHistory = [...prevChatHistory];
              const newImage = {
                ...data,
                imageType: imageGenerateType,
              };
              if (updatedHistory[index].generatedImages) {
                updatedHistory[index].generatedImages.push(newImage);
              } else {
                updatedHistory[index].generatedImages = [newImage];
              }

              return updatedHistory;
            });
            setImageGenerateType(4);
            setImageGeneratePrompt("");
          }
        })
        .catch((err) => {
          setGenerateLoading(index, false);
          console.log(err);
        });
    }
  };

  /*play pause function start */
  const audioRef = useRef(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState({});
  const [isAudioEnded, setIsAudioEnded] = useState({});

  const base64toBlob = (base64, mimeType) => {
    const byteCharacters = atob(base64);
    const byteArray = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([byteArray], { type: mimeType });
  };

  const fetchAudioData = async (index, message) => {
    const mainquery = "/synthesize/";
    try {
      fetch(host.chaturl + mainquery, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
          "X-API-Key": host.textToSpeechApikey,
        },
        body: JSON.stringify({
          text: message,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          const audioContent = data.audio_content;
          const audioBlob = base64toBlob(audioContent, "audio/mp3");
          const url = window.URL.createObjectURL(audioBlob);
          audioRef.current = new Audio(url);
          handlePlayAudio(index);
          audioRef.current.addEventListener("ended", () => handleAudioEnded(index));
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAudioEnded = (index) => {
    if (audioRef.current) {
      setIsAudioPlaying((prevState) => ({
        ...prevState,
        [index]: false,
      }));
      setIsAudioEnded((prevState) => ({
        ...prevState,
        [index]: true,
      }));
    }
  };

  const handlePlayAudio = (index) => {
    if (audioRef.current) {
      setIsAudioPlaying((prevState) => ({
        ...prevState,
        [index]: true,
      }));
      setIsAudioEnded((prevState) => ({
        ...prevState,
        [index]: false,
      }));
      audioRef.current.play();
    }
  };

  const handlePauseAudio = (index) => {
    if (audioRef.current) {
      setIsAudioPlaying((prevState) => ({
        ...prevState,
        [index]: false,
      }));
      setIsAudioEnded((prevState) => ({
        ...prevState,
        [index]: false,
      }));
      audioRef.current.pause();
    }
  };

  const handleResumeAudio = (index) => {
    if (audioRef.current) {
      setIsAudioPlaying((prevState) => ({
        ...prevState,
        [index]: true,
      }));
      audioRef.current.play();
    }
  };

  const cleanText = (text) => {
    // Remove styled elements
    const strippedText = text.replace(/<[^>]*>/g, ""); // This regex removes HTML tags

    // Remove non-alphanumeric characters except spaces
    const cleanText = strippedText.replace(/[^\w\s]/gi, "");

    // Remove extra whitespaces and newline characters
    const finalText = cleanText.replace(/\s+/g, " ").trim();

    return finalText;
  };

  /*play pause function end */

  //Speech to text functionality begins

  const [micOn, setMicOn] = useState(false);

  const { transcript, listening, resetTranscript } = useSpeechRecognition();
  const handleStart = () => {
    SpeechRecognition.startListening({ continuous: true });
  };
  const handleStop = () => {
    handleMessage(transcript);
    SpeechRecognition.abortListening();
    resetTranscript();
    setRequest("");
  };

  const handleMic = () => {
    setMicOn(!micOn);
  };

  useEffect(() => {
    if (listening && transcript.length > 0) {
      timeoutId = setTimeout(() => {
        console.log("Timeout: No speech detected. Stopping listening.");
        handleMic();
      }, 5000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [transcript, listening]);

  useEffect(() => {
    if (micOn) {
      handleStart();
    } else {
      handleStop();
    }
  }, [micOn]);

  //speech to text functionality ends

  //basic chat functionality begins

  let timeoutId;
  const [request, setRequest] = useState("");
  const [loading, setLoading] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [chatId, setChatId] = useState(null);
  const [chatTime, setChatTime] = useState(0);
  const [pageLoaded, setPageLoaded] = useState(true);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [data, setData] = useState("");
  const [sourceLoading, setSourceLoading] = useState(false);
  const [currentLanguages, setCurrentLanguages] = useState([]);
  const [translatedResponses, setTranslatedResponses] = useState({});
  const [selectedText, setSelectedText] = useState("");
  const [imageLoading, setImageLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const [relatedQuestionsLoading, setRelatedQuestionsLoading] = useState(false);
  const [relatedQuestions, setRelatedQuestions] = useState(null);
  const onClose = () => {
    setSnackbar(false);
  };

  const handleMessage = (message) => {
    if (message) {
      setChatHistory((prevChatHistory) => [
        ...prevChatHistory,
        {
          request: message,
        },
      ]);
      const message_id = uuidv4();
      fetchData(message, message_id);
      setRequest("");
    } else {
      setRequest("");
      return;
    }
  };
  const getSources = (message_id, query) => {
    setImageLoading(true);
    fetch(host.chaturl + `/synthesize/${chatId}/search/${message_id}?query=${query}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setImageLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setImageLoading(false);
          setChatHistory((prevChatHistory) => {
            const updatedHistory = [...prevChatHistory];
            const lastObjectIndex = updatedHistory.length - 1;
            let temp = "";
            let responseGraphData = "";
            if (lastObjectIndex >= 0) {
              let mermaidRegex = /```mermaid[\s\S]*?```end/g;
              let graphDataMatches = data.ai?.match(mermaidRegex);
              if (graphDataMatches && graphDataMatches.length > 0) {
                responseGraphData = graphDataMatches[0].replace("```mermaid", "").replace("```end", "");
                temp = data.ai?.replace(graphDataMatches[0], "```marked");
              }

              // Update the last object
              updatedHistory[lastObjectIndex] = {
                ...updatedHistory[lastObjectIndex],
                message_id: message_id,
                top_images: data?.top_images?.length > 0 ? data.top_images : null,
                top_videos: data?.top_videos?.length > 0 ? data.top_videos : null,
                throughHistory: true,
                graphData: responseGraphData,
              };
            }

            return updatedHistory;
          });
        }
      })
      .catch((err) => {
        setImageLoading(false);
        console.log(err);
      });
  };

  const getChatDetails = (message_id) => {
    fetch(host.chaturl + `/chat/${chatId}/message/${message_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSourceLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setSourceLoading(false);
        setChatHistory((prevChatHistory) => {
          const updatedHistory = [...prevChatHistory];
          const lastObjectIndex = updatedHistory.length - 1;
          let temp = "";
          let responseGraphData = "";
          if (lastObjectIndex >= 0) {
            let mermaidRegex = /```mermaid[\s\S]*?```end/g;
            let graphDataMatches = data.ai?.match(mermaidRegex);
            if (graphDataMatches && graphDataMatches.length > 0) {
              responseGraphData = graphDataMatches[0].replace("```mermaid", "").replace("```end", "");
              temp = data.ai?.replace(graphDataMatches[0], "```marked");
            }
            // Update the last object
            updatedHistory[lastObjectIndex] = {
              ...updatedHistory[lastObjectIndex],

              message_id: data.message_id,
              throughHistory: true,
              graphData: responseGraphData,
              response: temp ? temp : data.ai ? `${data.ai}` : "",
              rawResponse: temp ? temp : data.ai ? `${data.ai}` : "",
              top_results: data?.links?.length > 0 ? data?.links : null,
              top_images: null,
              top_videos: null,
            };
          }
          return updatedHistory;
        });
        if (data.links && data.links.length > 0) {
          getSources(data.message_id, data.search_query);
        } else {
          setImageLoading(false);
        }
      })
      .catch((err) => {
        setSourceLoading(false);
        console.log(err);
      });
  };

  const getRelatedQuestions = (chat_id) => {
    //chat_id === chatId
    fetch(host.chaturl + `/chat/${chat_id}/followup`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSourceLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setRelatedQuestions(data);
        setRelatedQuestionsLoading(false);
      })
      .catch((err) => {
        setSourceLoading(false);
        console.log(err);
      });
  };

  const handleTabSwitch = (message, message_id) => {
    if (parseInt(localStorage.getItem("streamTries")) > 10) {
      setSeverity("error");
      setMessage("Sorry, we are unable to process your request at the moment. Please try again later.");
      setSnackbar(true);
      localStorage.setItem("streamTries", 0);
      return;
    } else {
      //setting time delay to avoid the error
      localStorage.setItem("streamTries", parseInt(localStorage.getItem("streamTries")) + 1);
      setTimeout(() => {
        fetchData(message, message_id);
      }, 5000);
    }
  };

  const fetchData = async (message, message_id) => {
    let url;
    if (!message) {
      return;
    }
    setRelatedQuestionsLoading(true);
    setLoading(true);
    setData("");
    setSourceLoading(true);
    setImageLoading(true);

    url = `${host.chaturl}/chat/${chatId}/default?&message_id=${message_id}&model=${Number(model) === 7 ? 1 : model}`;

    await fetchEventSource(url, {
      method: "POST",
      headers: {
        Accept: "text/event-stream",
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        user_question: message,
      }),
      onopen(res) {
        if (res.ok && res.status === 200) {
          console.log("Connection made ", res);
          localStorage.setItem("streamTries", 0);
          // setStreamClosed(false);
        } else if (res.status > 400 && res.status < 500 && res.status !== 429) {
          console.log("Client-side error ", res);
        } else if (res.status === 400) {
          handleTabSwitch(message, message_id);
        }
      },
      onmessage(event) {
        setLoading(false);
        // const parsedData = JSON.parse(event.data);
        //setData((eventData) => eventData + event.data);
        const correctedData = event.data.replace(/<br\/>/g, "\n").replace(/<b>(.*?)<\/b>/g, "**$1**");
        setData((eventData) => eventData + correctedData);
        // Important to set the data this way, otherwise old data may be overwritten if the stream is too fast
      },
      onclose() {
        if (localStorage.getItem("streamTries") === "0") {
          setLoading(false);
          getChatDetails(message_id);
          getRelatedQuestions(chatId);
        }
        // getSources(message_id, message);
        // setStreamClosed(true);
        console.log("Connection closed by the server");
      },
      onerror(err) {
        setLoading(false);
        console.log("There was an error from server", err);
      },
    });
  };

  const getSelectedChat = (chat_id) => {
    setPageLoaded(false);
    fetch(host.chaturl + `/chat/${chat_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPageLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data?.created_at) {
          setChatTime(data.created_at);
        }
        if (data?.chat_name) {
          setTitle(data.chat_name);
        } else {
          setTitle("Untitled");
        }
        if (data) {
          const temp = data.chat_history.map((chat) => {
            let tempData = "";
            let responseGraphData = "";
            let mermaidRegex = /```mermaid[\s\S]*?```end/g;
            let graphDataMatches = chat.ai?.match(mermaidRegex);
            if (graphDataMatches && graphDataMatches.length > 0) {
              responseGraphData = graphDataMatches[0].replace("```mermaid", "").replace("```end", "");
              tempData = chat.ai?.replace(graphDataMatches[0], "```marked");
            }
            return {
              request: chat.human ? chat.human : "NA",
              response: tempData ? tempData : chat.ai ? `${chat.ai}` : "NA",
              message_id: chat.id,
              thumbsup: chat.upvote !== null && chat.upvote !== undefined && chat.upvote === true ? true : false,
              thumbsdown: chat.upvote !== null && chat.upvote !== undefined && chat.upvote === false ? true : false,
              top_results: chat.links?.length > 0 ? chat.links : null,
              top_images: chat.search_result?.top_images?.length > 0 ? chat.search_result.top_images : null,
              top_videos: chat.search_result?.top_videos?.length > 0 ? chat.search_result.top_videos : null,
              rawResponse: tempData ? tempData : chat.ai ? `${chat.ai}` : "",
              generatedImages: chat.images_generated?.length > 0 ? chat.images_generated : null,
              throughHistory: true,
              graphData: responseGraphData,
            };
          });
          setChatHistory(temp);
          setPageLoaded(true);
          setChatId(data.id);
          getRelatedQuestions(data.id);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageLoaded(true);
      });
  };

  const sendFeedBack = (chat_id, message_id, reaction) => {
    let upvote;
    if (reaction === "thumbsup") {
      upvote = true;
    } else {
      upvote = false;
    }

    fetch(host.chaturl + `/chat/${chat_id}/feedback/${message_id}?upvote=${upvote}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setSeverity("success");
          setMessage("Thanks For Your Feedback");
          setSnackbar(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (id && typeof id === "string") {
      setRequest("");
      getSelectedChat(id);

      localStorage.setItem("chat_id", id);
    }
  }, [id]);

  useEffect(() => {
    if (!auth) {
      navigate("/logout");
    }
  }, [auth]);

  useEffect(() => {
    if (data !== "" && data.includes("```mermaid") === false) {
      setChatHistory((prevChatHistory) => {
        const updatedHistory = [...prevChatHistory];
        const lastObjectIndex = updatedHistory.length - 1;

        if (lastObjectIndex >= 0) {
          updatedHistory[lastObjectIndex] = {
            ...updatedHistory[lastObjectIndex],
            throughHistory: false,
            response: data,
            rawResponse: data ? data : "",
          };
        }
        return updatedHistory;
      });
    }

    if (data.includes("```end") && graphLoading) {
      setGraphLoading(false);
      let mermaidRegex = /```mermaid[\s\S]*?```end/g;
      let graphDataMatches = data.match(mermaidRegex);
      if (graphDataMatches && graphDataMatches.length > 0) {
        currentGraphData = graphDataMatches[0].replace("```mermaid", "").replace("```end", "");
        const temp = data.replace(graphDataMatches[0], "```marked");
        setGraphData(currentGraphData);
        setData((prevData) => prevData.replace(graphDataMatches[0], "```marked"));
      }
    } else if (data.includes("```mermaid") && graphLoading === false && data.includes("```end") === false) {
      setGraphLoading(true);
    }
  }, [data]);

  const getProfile = () => {
    // setIsLoaded(false);
    fetch(host.chaturl + `/user`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          // setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setProfile(data);
          // setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        //  setIsLoaded(true);
      });
  };

  useEffect(() => {
    localStorage.setItem("streamTries", 0); // necessary for tab switch logic
    getProfile();
  }, []);

  const scrollingDivRef = useRef(null);
  // Scroll to the top of the chat container when chatHistory updates
  useEffect(() => {
    if (chatHistory.length > 0) {
      scrollingDivRef.current.scrollIntoView({ behavior: "smooth" });
      setCurrentLanguages(Array(chatHistory.length).fill("english"));
      setShowAll(Array(chatHistory.length).fill(false));
      setGenerateImageLoading(Array(chatHistory.length).fill(false));
      setShowVideo(Array(chatHistory.length).fill(false));
    }
  }, [chatHistory]);

  //basic chat functionality ends

  //delete chat functionality begins

  const handleDeleteChat = (chat_id) => {
    fetch(host.chaturl + `/chat/${chat_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setSeverity("success");
          setMessage("Chat deleted successfully");
          setSnackbar(true);
          localStorage.removeItem("chat_id");
          navigate("/home");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //delete chat functionality ends

  const [isActive, setIsActive] = useState(() => localStorage.getItem("isActive") === "true");
  const handleToggleClick = () => {
    setIsActive(!isActive);
    localStorage.setItem("isActive", !isActive);
  };
  useEffect(() => {
    if (isActive) {
      document.body.classList.add("mini-sidebar");
    } else {
      document.body.classList.remove("mini-sidebar");
    }
  }, [localStorage.getItem("isActive")]);

  const models = {
    0: "gpt-3.5-turbo",
    1: "gpt-4o",
    2: "gpt-4-turbo",
    3: "gpt-4",
    4: "llama3-8b-8192",
    5: "mixtral-8x7b-32768",
    6: "gemma-7b-it",
    7: "Default",
  };

  const [model, setModel] = useState(7);

  return (
    <>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <MainPage>
        {pageLoaded ? (
          <div className="viewer-wrapper">
            <div className="deskhome_chat_wrapper ">
              <div className="desk_chat_wrapper">
          
                <div className="desk_chat_body">
                  <div className="chat_container  browserchatpannel">
                    <div className="desk_chat_panal">
                      <div className="desk_chat_inner_box ">
                        <div className="desk_chat_contentwrapper">
                          <div className="desk_chat_contentbox">
                            <div className="desk_chat_bodydown">
                              <div className="desk_chat_body_Inner">
                                <div className="desk_message_list_container">
                                  <div className={`desk_message_list ${isListening ? "listening" : ""}`}>
                                    <section className="chat_message">
                                      
                                            <div class="chat_box_wrapper browser_chat_flex">
                                            <div className="desk_chat_head">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="top-chatbar">
                          <div className="d-flex align-items-center">
                            <div className="minimize_sidebar">
                              <IconButton aria-label="hide" onClick={handleToggleClick}>
                                <MenuIcon />
                              </IconButton>
                            </div>
                          </div>
                          <div className="chat_title">
                            {isEditing ? (
                              <TextField
                                id="outlined-basic"
                                placeholder=" "
                                size="small"
                                type="text"
                                value={title}
                                onChange={handleInputChange}
                                onBlur={handleInputBlur}
                                onKeyPress={handleInputKeyPress}
                                autoFocus
                              />
                            ) : (
                              <div className="d-flex align-items-center gap-3">
                                <h2 onClick={handleTitleClick}>{title ? title : "New chat"}</h2>
                                <span className="chattime">
                                  <i className="las la-clock"></i> {getTimeDifference(chatTime === 0 ? new Date() : chatTime)}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="viewer-actions">
                            <Tooltip className="blue-tooltip" title="Share Chat" placement="bottom" arrow>
                              <Link
                                to="#"
                                className=" "
                                onClick={() => {
                                  activesharechat();
                                }}
                              >
                                <ShareOutlinedIcon fontSize="small" />
                              </Link>
                            </Tooltip>
                            <Tooltip className="blue-tooltip" title="Download Chat" placement="bottom" arrow>
                              <Link
                                to="#"
                                className=" "
                                onClick={() => {
                                  handleDownloadChat(chatHistory, title);
                                }}
                              >
                                <FileDownloadOutlinedIcon fontSize="small" />
                              </Link>
                            </Tooltip>
                            {/* <Tooltip className="blue-tooltip" title="Reset Chat" placement="bottom" arrow>
                              <Link to="#" className=" ">
                                <ReplayOutlinedIcon fontSize="small" />
                              </Link>
                            </Tooltip> */}
                            <Tooltip className="blue-tooltip" title="Delete Chat" placement="bottom" arrow>
                              <Link to="#" className=" " onClick={activedelet}>
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                              </Link>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                                              {chatHistory &&
                                                chatHistory.length > 0 &&
                                                chatHistory.map((chat, index) => (
                                                  <div class="chat_box_flex " key={index}>
                                                    <div className="left_all_content_wrapper">
                                                      <div className="left_chat_content">
                                                        <div className="chat_flex">
                                                          <div className="chat_content" style={{ backgroundColor: "#eafafc" }}>
                                                            <div className="chat_message_title">
                                                              <div className="chat_sender">
                                                                {" "}
                                                                <div className="chat_avtar">
                                                                  <Avatar sx={{ width: "35px", height: "35px", fontSize: "14px", backgroundColor: "#00bdd6" }}>
                                                                    {profile ? profile.fullname.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), "") : "NA"}
                                                                  </Avatar>
                                                                </div>{" "}
                                                                you
                                                              </div>
                                                              <h4>
                                                                {chat.request !== "" ? (
                                                                  <ReactReadMoreReadLess charLimit={350} readMoreText={"Read more ▼"} readLessText={"Read less ▲"}>
                                                                    {chat.request}
                                                                  </ReactReadMoreReadLess>
                                                                ) : (
                                                                  "NA"
                                                                )}
                                                              </h4>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        {/* </div> */}
                                                        {/* )} */}
                                                        <div className="chat_flex">
                                                          <div className="chat_content" style={{ backgroundColor: "#fbf9ff" }}>
                                                            <div className="answer_wrapper chat_sections">
                                                              <div className="answer-head">
                                                                <div className="sources_title">
                                                                  {/* <div className="chat_avtar  ">
                                                            <Avatar sx={{ width: "35px", height: "35px", fontSize: "16px", backgroundColor: "#8353e2" }}> AI </Avatar>
                                                          </div> */}
                                                                  <div className="sourse-icon">
                                                                    <div className="chat_brain">
                                                                      <TravelExploreIcon fontSize="small" />
                                                                      <span>{"Browser"}</span>
                                                                    </div>
                                                                  </div>
                                                                  <span>/</span>
                                                                  <h5>Answer</h5>
                                                                </div>
                                                              </div>
                                                              <div className="answer_body">
                                                                {loading && index === chatHistory.length - 1 && (
                                                                  <motion.div
                                                                    initial={{
                                                                      opacity: 0,
                                                                      y: 3,
                                                                    }}
                                                                    animate={{
                                                                      opacity: 1,
                                                                      y: 0,
                                                                    }}
                                                                    transition={{
                                                                      duration: 0.4,
                                                                      delay: 0.2,
                                                                    }}
                                                                    className="skeleton_loader"
                                                                  >
                                                                    <ChatContentLoader />
                                                                  </motion.div>
                                                                )}
                                                                {(chat.response || !loading) && (
                                                                  <>
                                                                    <motion.div
                                                                      initial={{
                                                                        opacity: 0,
                                                                        y: 5,
                                                                      }}
                                                                      animate={{
                                                                        opacity: 1,
                                                                        y: 0,
                                                                      }}
                                                                      transition={{
                                                                        duration: 0.4,
                                                                        delay: 0.2,
                                                                      }}
                                                                      className="answer_content   "
                                                                    >
                                                                      {currentLanguages[index] === "hindi" ? (
                                                                        <>
                                                                          {translatedResponses[index] && (
                                                                            <div>
                                                                              {translatedResponses[index]
                                                                                .split("\n")
                                                                                .filter((row) => row.trim().length > 0 && !/^[-| ]+$/.test(row))
                                                                                .map((row, index) => {
                                                                                  if (row.includes("|")) {
                                                                                    // This is a table row
                                                                                    return (
                                                                                      <table
                                                                                        key={index}
                                                                                        style={{ border: "1px solid black", borderCollapse: "collapse", tableLayout: "fixed", width: "100%" }}
                                                                                      >
                                                                                        <tbody>
                                                                                          <tr>
                                                                                            {row
                                                                                              .split("|")
                                                                                              .filter((cell, cellIndex) => cellIndex > 0 && cellIndex < row.split("|").length - 1)
                                                                                              .map((cell, cellIndex) => (
                                                                                                <td key={cellIndex} style={{ border: "1px solid black", padding: "5px" }}>
                                                                                                  <ReactMarkdown>{cell.trim()}</ReactMarkdown>
                                                                                                </td>
                                                                                              ))}
                                                                                          </tr>
                                                                                        </tbody>
                                                                                      </table>
                                                                                    );
                                                                                  } else {
                                                                                    // This is a normal text row
                                                                                    return <ReactMarkdown key={index}>{row}</ReactMarkdown>;
                                                                                  }
                                                                                })}
                                                                            </div>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                            {chat.rawResponse && ( <MermaidEditor rawResponse={chat.rawResponse} /> )}
                                                                          </>
                                                                      )}
                                                                    </motion.div>
                                                                    {chat.rawResponse && (
                                                                      <div className="answer_actions">
                                                                        <div className="left_action">
                                                                          <div className="likedislike">
                                                                            <Tooltip className="blue-tooltip" title="Like" TransitionComponent={Zoom} placement="top" arrow>
                                                                              <Checkbox
                                                                                {...label}
                                                                                icon={<ThumbUpAltOutlinedIcon />}
                                                                                checkedIcon={<ThumbUpIcon />}
                                                                                // checked={true}
                                                                                onClick={() => {
                                                                                  chat.thumbsup = true;
                                                                                  chat.thumbsdown = false;
                                                                                  sendFeedBack(chatId, chat.message_id, "thumbsup");
                                                                                }}
                                                                                checked={chat?.thumbsup}
                                                                              />
                                                                            </Tooltip>
                                                                            <Tooltip className="blue-tooltip" title="Dislike" TransitionComponent={Zoom} placement="top" arrow>
                                                                              <Checkbox
                                                                                {...label}
                                                                                icon={<ThumbDownAltOutlinedIcon />}
                                                                                checkedIcon={<ThumbDownIcon />}
                                                                                onClick={() => {
                                                                                  chat.thumbsdown = true;
                                                                                  chat.thumbsup = false;
                                                                                  sendFeedBack(chatId, chat.message_id, "thumbsdown");
                                                                                }}
                                                                                checked={chat?.thumbsdown}
                                                                              />
                                                                            </Tooltip>
                                                                          </div>
                                                                          {/* <div className="sharechat">
                                                                            <Tooltip className="blue-tooltip" title="Share" TransitionComponent={Zoom} placement="top" arrow>
                                                                              <Link to="">
                                                                                <Chip variant="outlined" color="info" label="Share" icon={<ShareOutlinedIcon fontSize="small" />} />
                                                                              </Link>
                                                                            </Tooltip>
                                                                          </div> */}
                                                                          <div className="copychat">
                                                                            <Tooltip className="blue-tooltip" title="Copy Message" TransitionComponent={Zoom} placement="top" arrow>
                                                                              <Chip
                                                                                label={copyStatus[index] ? "Copied" : "Copy"}
                                                                                variant="outlined"
                                                                                onClick={() =>
                                                                                  handleClick(index, currentLanguages[index] === "english" ? chat.rawResponse : translatedResponses[index])
                                                                                }
                                                                                color={copyStatus[index] ? "success" : "primary"} // Setting color based on copy status
                                                                                icon={
                                                                                  // isLoading ? (
                                                                                  //   <CircularProgress
                                                                                  //     size={
                                                                                  //       15
                                                                                  //     }
                                                                                  //   />
                                                                                  // ) :
                                                                                  copyStatus[index] ? <CheckIcon fontSize="small" /> : null
                                                                                }
                                                                              />
                                                                            </Tooltip>
                                                                          </div>
                                                                          <div className="playpause">
                                                                            {isAudioPlaying[index] ? (
                                                                              <>
                                                                                <Tooltip className="blue-tooltip" title="Pause Audio" TransitionComponent={Zoom} placement="top" arrow>
                                                                                  <Button
                                                                                    variant="text"
                                                                                    style={{
                                                                                      textTransform: "capitalize",
                                                                                      display: "flex",
                                                                                      alignItems: "center",
                                                                                      gap: 4,
                                                                                    }}
                                                                                    onClick={() => handlePauseAudio(index)}
                                                                                    className="text-danger"
                                                                                  >
                                                                                    <PauseCircleOutlineOutlinedIcon />
                                                                                    <span>Pause</span>
                                                                                  </Button>
                                                                                </Tooltip>
                                                                              </>
                                                                            ) : (
                                                                              <>
                                                                                {isAudioEnded[index] !== false && (
                                                                                  <Tooltip className="blue-tooltip" title="Listen Audio" TransitionComponent={Zoom} placement="top" arrow>
                                                                                    <Button
                                                                                      variant="text"
                                                                                      style={{
                                                                                        textTransform: "capitalize",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: 4,
                                                                                      }}
                                                                                      onClick={() => {
                                                                                        const textToSend =
                                                                                          currentLanguages[index] === "english" ? cleanText(chat.rawResponse) : translatedResponses[index];
                                                                                        fetchAudioData(index, textToSend);
                                                                                      }}
                                                                                      className=" "
                                                                                    >
                                                                                      <PlayCircleFilledWhiteOutlinedIcon />
                                                                                      <span>Listen</span>
                                                                                    </Button>
                                                                                  </Tooltip>
                                                                                )}
                                                                              </>
                                                                            )}
                                                                            {isAudioPlaying[index] === false && isAudioEnded[index] === false && (
                                                                              <Tooltip className="blue-tooltip" title="Resume Audio" TransitionComponent={Zoom} placement="top" arrow>
                                                                                <Button
                                                                                  variant="text"
                                                                                  style={{
                                                                                    textTransform: "capitalize",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    gap: 4,
                                                                                  }}
                                                                                  onClick={() => handleResumeAudio(index)}
                                                                                  className="text-success"
                                                                                >
                                                                                  <PlayCircleFilledWhiteOutlinedIcon />
                                                                                  <span>Resume</span>
                                                                                </Button>
                                                                              </Tooltip>
                                                                            )}
                                                                          </div>
                                                                          <div className="switchlanguage">
                                                                            <Tooltip className="blue-tooltip" title="Change Language" TransitionComponent={Zoom} placement="top" arrow>
                                                                              <FormControlLabel
                                                                                size="small"
                                                                                control={
                                                                                  <IOSSwitch
                                                                                    size="small"
                                                                                    sx={{
                                                                                      m: 1,
                                                                                    }}
                                                                                    fontSize="small"
                                                                                    checked={currentLanguages[index] === "hindi"}
                                                                                    onChange={() => handleLanguageToggle(index, chat.rawResponse)}
                                                                                  />
                                                                                }
                                                                                label={currentLanguages[index] === "hindi" ? "हिंदी" : "English"}
                                                                              />
                                                                            </Tooltip>
                                                                          </div>
                                                                        </div>
                                                                        <div className="right_action"></div>
                                                                      </div>
                                                                    )}
                                                                  </>
                                                                )}
                                                              </div>
                                                            </div>
                                                            <div className={sourceLoading || (chat.top_results && chat.top_results.length > 0) ? "sources_wrapper chat_sections" : ""}>
                                                              {(sourceLoading || (chat.top_results && chat.top_results.length > 0)) && (
                                                                <div className="sources-head">
                                                                  <div className="sources_title">
                                                                    <div className="sourse-icon">
                                                                      <SpeakerNotesOutlinedIcon fontSize="small" />
                                                                    </div>
                                                                    <h5>Related Results</h5>
                                                                  </div>
                                                                </div>
                                                              )}
                                                              {/* {chat.top_results &&
                                                                    chat
                                                                      .top_results
                                                                      .length >
                                                                      0 && ( */}
                                                              {/* <div className="sources_wrapper chat_sections"> */}

                                                              <div className="sources_body">
                                                                <div className="all_sources">
                                                                  {sourceLoading && index === chatHistory.length - 1 && (
                                                                    <motion.div
                                                                      initial={{
                                                                        opacity: 0,
                                                                        y: 3,
                                                                      }}
                                                                      animate={{
                                                                        opacity: 1,
                                                                        y: 0,
                                                                      }}
                                                                      transition={{
                                                                        duration: 0.4,
                                                                        delay: 0.2,
                                                                      }}
                                                                      className="skeleton_loader sourseloader"
                                                                    >
                                                                      <SourceLoader />
                                                                    </motion.div>
                                                                  )}
                                                                  {chat.top_results?.length > 0 && (
                                                                    <div className="sources-flex">
                                                                      {chat?.top_results?.slice(0, Math.min(3, chat.top_results.length)).map((result, index) => (
                                                                        <motion.div
                                                                          initial={{
                                                                            opacity: 0,
                                                                            y: 3,
                                                                          }}
                                                                          animate={{
                                                                            opacity: 1,
                                                                            y: 0,
                                                                          }}
                                                                          transition={{
                                                                            duration: 0.4,
                                                                            delay: 0.2,
                                                                          }}
                                                                          key={index}
                                                                          className="source_box"
                                                                          onClick={() => {
                                                                            window.open(result.link, "_blank");
                                                                          }}
                                                                        >
                                                                          <div className="source_box_flex">
                                                                            <div className="sourcewebsite">
                                                                              <div className="website_left">
                                                                                <div className="webname">{result?.link ? new URL(result.link).hostname.split(".").slice(-2, -1)[0] : "NA"}</div>
                                                                              </div>
                                                                            </div>
                                                                            <div className="sourcename">
                                                                              <div className="sourcecontent">{result.snippet ? result.snippet : "NA"}</div>
                                                                            </div>
                                                                          </div>
                                                                        </motion.div>
                                                                      ))}
                                                                      {!showAll[index] ? (
                                                                        <>
                                                                          {chat.top_results.length > 3 && (
                                                                            <motion.div
                                                                              initial={{
                                                                                opacity: 0,
                                                                                y: 3,
                                                                              }}
                                                                              animate={{
                                                                                opacity: 1,
                                                                                y: 0,
                                                                              }}
                                                                              transition={{
                                                                                duration: 0.4,
                                                                                delay: 0.2,
                                                                              }}
                                                                              className="source_box show-more-box"
                                                                              onClick={() => {
                                                                                handleClickShowMore(index);
                                                                              }}
                                                                            >
                                                                              <div className="source_box_flex">
                                                                                <div className="sourcewebsite">
                                                                                  <div className="website_left">
                                                                                    <div className="webname"> Show {chat.top_results.length - 3} more </div>
                                                                                  </div>
                                                                                </div>
                                                                              </div>
                                                                            </motion.div>
                                                                          )}
                                                                        </>
                                                                      ) : (
                                                                        <>
                                                                          {chat.top_results.length > 3 &&
                                                                            chat?.top_results?.slice(3).map((result, index) => (
                                                                              <motion.div
                                                                                initial={{
                                                                                  opacity: 0,
                                                                                  y: 3,
                                                                                }}
                                                                                animate={{
                                                                                  opacity: 1,
                                                                                  y: 0,
                                                                                }}
                                                                                transition={{
                                                                                  duration: 0.4,
                                                                                  delay: 0.2,
                                                                                }}
                                                                                key={index}
                                                                                className="source_box"
                                                                                onClick={() => {
                                                                                  window.open(result.link, "_blank");
                                                                                }}
                                                                              >
                                                                                <div className="source_box_flex">
                                                                                  <div className="sourcewebsite">
                                                                                    <div className="website_left">
                                                                                      <div className="webname">{result?.link ? new URL(result.link).hostname.split(".").slice(-2, -1)[0] : "NA"}</div>
                                                                                    </div>
                                                                                  </div>
                                                                                  <div className="sourcename">
                                                                                    <div className="sourcecontent">{result.snippet ? result.snippet : "NA"}</div>
                                                                                  </div>
                                                                                </div>
                                                                              </motion.div>
                                                                            ))}
                                                                        </>
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {relatedQuestions !== null && index === chatHistory?.length - 1 && !relatedQuestionsLoading && (
                                                        <div className="related_wrapper chat_sections">
                                                          <div className="related-head">
                                                            <div className="sources_title">
                                                              <div className="sourse-icon">
                                                                <DynamicFeedOutlinedIcon fontSize="small" />
                                                              </div>
                                                              <h5>Related</h5>
                                                            </div>
                                                          </div>
                                                          <div className="related_body">
                                                            <div className="related_list">
                                                              <nav aria-label="main ">
                                                                <List>
                                                                  {Object.entries(relatedQuestions).map(([key, question], index) => (
                                                                    <React.Fragment key={key}>
                                                                      <ListItem disablePadding>
                                                                        <ListItemButton onClick={() => handleMessage(question)}>
                                                                          <ListItemIcon>
                                                                            <AddIcon fontSize="small" />
                                                                          </ListItemIcon>
                                                                          <ListItemText primary={question} />
                                                                        </ListItemButton>
                                                                      </ListItem>
                                                                      {index < Object.keys(relatedQuestions).length - 1 && <Divider />}
                                                                    </React.Fragment>
                                                                  ))}
                                                                </List>
                                                              </nav>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      <div id="scrolling" ref={scrollingDivRef}></div>
                                                    </div>
                                                    <div className="right_image__content">
                                                      <div className="browser_image_wrapper">
                                                        {((imageLoading && index === chatHistory.length - 1) ||
                                                          (chatHistory[index].top_images && chatHistory[index].top_images.length > 0) ||
                                                          (showVideo[index] === true && chatHistory[index].top_videos?.length > 0) ||
                                                          generateImageLoading[index] ||
                                                          chatHistory[index].generatedImages?.length > 0) && (
                                                          <div className="images_grid_box">
                                                            {imageLoading && index === chatHistory.length - 1 ? (
                                                              <motion.div
                                                                initial={{
                                                                  opacity: 0,
                                                                  y: 3,
                                                                }}
                                                                animate={{
                                                                  opacity: 1,
                                                                  y: 0,
                                                                }}
                                                                transition={{
                                                                  duration: 0.4,
                                                                  delay: 0.2,
                                                                }}
                                                                className="skeleton_loader"
                                                              >
                                                                <BrowserImageLoader />
                                                              </motion.div>
                                                            ) : (
                                                              <>
                                                                <div className="images_grid">
                                                                  {chatHistory[index].top_images?.length > 0 &&
                                                                    chatHistory[index].top_images.map((topImage, index) => <ImageComponent key={index} src={topImage} alt="Recommendations" />)}
                                                                </div>
                                                                {showVideo[index] === true && chatHistory[index].top_videos?.length > 0 && (
                                                                  <div className="images_grid">
                                                                    {chatHistory[index].top_videos.map((topVideo, index) => (
                                                                      <div className="image_box" key={index}>
                                                                        <LightgalleryItem className="" group="videos" src={topVideo.video_url}>
                                                                          <video autoplay poster={topVideo.thumbnail_url} src={topVideo.video_url}>
                                                                            Your browser does not support the video tag.
                                                                          </video>
                                                                          <div className="videosign">
                                                                            {" "}
                                                                            Watch <PlayCircleFilledOutlinedIcon size="small" />
                                                                          </div>
                                                                        </LightgalleryItem>
                                                                      </div>
                                                                    ))}
                                                                  </div>
                                                                )}
                                                              </>
                                                            )}
                                                            {chatHistory[index].generatedImages?.length > 0 ? (
                                                              <div className="images_grid">
                                                                {chatHistory[index].generatedImages.map((generatedImage, imageIndex) => (
                                                                  <div className="image_box" key={imageIndex}>
                                                                    {generateImageLoading[index] &&
                                                                    console.log(chatHistory[index].generatedImages.length - 1) &&
                                                                    imageIndex === chatHistory[index].generatedImages.length - 1 ? (
                                                                      <motion.div
                                                                        initial={{
                                                                          opacity: 0,
                                                                          y: 3,
                                                                        }}
                                                                        animate={{
                                                                          opacity: 1,
                                                                          y: 0,
                                                                        }}
                                                                        transition={{
                                                                          duration: 0.4,
                                                                          delay: 0.2,
                                                                        }}
                                                                        className="skeleton_loader"
                                                                      >
                                                                        <GenerateImageLoader />
                                                                      </motion.div>
                                                                    ) : (
                                                                      <LightgalleryItem className="" group="generated" src={generatedImage.url}>
                                                                        <img src={generatedImage.url} alt="Generated" />
                                                                      </LightgalleryItem>
                                                                    )}
                                                                    <div className="Regenerate_box">
                                                                      <span>
                                                                        {generatedImage.imageType === 0
                                                                          ? "Generated Painting"
                                                                          : generatedImage.imageType === 1
                                                                          ? "Generated Photograph"
                                                                          : generatedImage.imageType === 2
                                                                          ? "Generated Illustration"
                                                                          : generatedImage.imageType === 3
                                                                          ? "Generated Diagram"
                                                                          : "Generated Image"}
                                                                      </span>
                                                                    </div>
                                                                  </div>
                                                                ))}
                                                              </div>
                                                            ) : (
                                                              <>
                                                                {generateImageLoading[index] && (
                                                                  <motion.div
                                                                    initial={{
                                                                      opacity: 0,
                                                                      y: 3,
                                                                    }}
                                                                    animate={{
                                                                      opacity: 1,
                                                                      y: 0,
                                                                    }}
                                                                    transition={{
                                                                      duration: 0.4,
                                                                      delay: 0.2,
                                                                    }}
                                                                    className="skeleton_loader"
                                                                  >
                                                                    <GenerateImageLoader />
                                                                  </motion.div>
                                                                )}
                                                              </>
                                                            )}
                                                          </div>
                                                        )}
                                                        <div className="image_type_box">
                                                          {chatHistory[index].top_videos?.length > 0 && (
                                                            <div
                                                              className="image_type_cta"
                                                              onClick={() => {
                                                                handleShowVideo(index);
                                                              }}
                                                            >
                                                              <div className="sources_title">
                                                                <div className="sourse-icon">
                                                                  <VideoCameraBackOutlinedIcon fontSize="small" />
                                                                </div>
                                                                <h5>Videos</h5>
                                                              </div>
                                                              <IconButton color="primary" aria-label="add to shopping cart">
                                                                {showVideo[index] === true ? <RemoveIcon /> : <AddIcon />}
                                                              </IconButton>
                                                            </div>
                                                          )}
                                                          {!generateImageLoading[index] && (
                                                            <div
                                                              className="image_type_cta"
                                                              onClick={(event) => handleClickgenerateimg(event, chatHistory[index].message_id, chatHistory[index].request, index)}
                                                            >
                                                              <div className="sources_title">
                                                                <div className="sourse-icon">
                                                                  <PhotoFilterOutlinedIcon fontSize="small" />
                                                                </div>
                                                                <h5>Generate Image</h5>
                                                              </div>
                                                              <IconButton color="primary" aria-label="add to shopping cart">
                                                                <AddIcon />
                                                              </IconButton>
                                                            </div>
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              <Drawer
                                                variant="temporary"
                                                className="browser_chart_drawer"
                                                anchor="right"
                                                open={isOpengrapg}
                                                onClose={() => closeDrawergraph()}
                                                ModalProps={{
                                                  keepMounted: true,
                                                }}
                                              >
                                                <div className={`Browser_chart_render ${isOpengrapg ? "opengraph" : ""}`}>
                                                  <div className="right_chat_content_fix">
                                                    <div className="pdfView_head">
                                                      <div className="pdf_title">
                                                        <h2>Graph</h2>
                                                      </div>
                                                      <div className="viewer-actions">
                                                        <div className="library_pdf_close" style={{ marginLeft: "10px" }}>
                                                          <Tooltip className="blue-tooltip" title="Close Chart" TransitionComponent={Zoom} placement="top" arrow>
                                                            <IconButton className=" " onClick={closeDrawergraph}>
                                                              <CloseIcon />
                                                            </IconButton>
                                                          </Tooltip>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="Chart_pdfView_body">
                                                      <div className="Chart_pdf_scroller pdf_scroller">
                                                        {graphData && (
                                                          <TransformWrapper
                                                            defaultScale={1}
                                                            defaultPositionX={0}
                                                            defaultPositionY={0}
                                                            options={{ limitToBounds: true, minScale: 0.5, maxScale: 4, centerContent: true }}
                                                            wheel={{ step: 0.5 }}
                                                            centerOnInit={true}
                                                          >
                                                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                                              <>
                                                                <div className="tools">
                                                                  <IconButton aria-label="Zoom" onClick={() => zoomIn()}>
                                                                    <ZoomInOutlinedIcon />
                                                                  </IconButton>
                                                                  <Link aria-label="Reset" onClick={() => resetTransform()}>
                                                                    Reset
                                                                  </Link>
                                                                  <IconButton aria-label="Zoomout" onClick={() => zoomOut()}>
                                                                    <ZoomOutOutlinedIcon />
                                                                  </IconButton>
                                                                </div>
                                                                <TransformComponent>
                                                                  <div className="browser_chart_container" key={graphKey}>
                                                                    <Mermaid chart={graphData} />
                                                                  </div>
                                                                </TransformComponent>
                                                              </>
                                                            )}
                                                          </TransformWrapper>
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </Drawer>
                                            </div>
                                            <div>

                                            </div>
                                          
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="bottom_chat_wrapper  ">
                            <ChatForm
                              chatLength={chatHistory?.length}
                              chatType={"browser"}
                              selectedText={selectedText}
                              setSelectedText={setSelectedText}
                              request={request}
                              handleMic={handleMic}
                              setMicOn={setMicOn}
                              transcript={transcript}
                              listening={listening}
                              setRequest={setRequest}
                              handleMessage={handleMessage}
                              browserMode={browserMode}
                              models={models}
                              model={model}
                              setModel={setModel}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <PageLoader />
        )}
        <Modal open={opendelete} onClose={handleClosedelete} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
          <Box className=" commonpopup  modal-common   popup-w35 ">
            <Link className="close" onClick={handleClosedelete}>
              X
            </Link>
            <div className="modal-body">
            <div className="popup_scroller"> 
           
              <div className="model-content text-center">
                <h3>Are you sure you want to delete?</h3>
              </div>
              <div className="modal-btn">
                <button
                  className="btn btn-success btn-block  "
                  onClick={() => {
                    handleDeleteChat(id);
                    handleClosedelete();
                  }}
                >
                  Delete forever
                </button>
                <button className="btn btn-danger btn-block  " onClick={handleClosedelete}>
                  Cancel
                </button>
              </div>
              </div>
            </div>
          </Box>
        </Modal>
        <Popover
          open={opengenerateimg}
          anchorEl={anchorElgenerateimg}
          onClose={handleClosegenerateimg}
          className="chatpopover"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div className="action-popup-wrapper  generateimage">
            <div className="action-popup-head">
              <div className="actionpopup_title">Choose a style</div>
              <Link to="#" className="slide-close" onClick={handleClosegenerateimg}>
                <span>X</span>
              </Link>
            </div>
            <div className="action-popup-body p-0">
              <div className="focus_items">
                <div className="focus_cta">
                  <Link to="" className={imageGenerateType === 0 ? "active" : ""} onClick={() => toggleImageGenerateType(0)}>
                    <h5>
                      <ColorLensOutlinedIcon />
                      Painting
                    </h5>
                    <span> Vibrant color strokes, expressive art.</span>
                  </Link>
                </div>
                <div className="focus_cta">
                  <Link to="" className={imageGenerateType === 1 ? "active" : ""} onClick={() => toggleImageGenerateType(1)}>
                    <h5>
                      <AddAPhotoOutlinedIcon />
                      Photograph
                    </h5>
                    <span>Captured moments, timeless memories.</span>
                  </Link>
                </div>
                <div className="focus_cta">
                  <Link to="" className={imageGenerateType === 2 ? "active" : ""} onClick={() => toggleImageGenerateType(2)}>
                    <h5>
                      <EditOutlinedIcon />
                      illustration
                    </h5>
                    <span>Whimsical scenes, imaginative characters.</span>
                  </Link>
                </div>
                <div className="focus_cta">
                  <Link to="" className={imageGenerateType === 3 ? "active" : ""} onClick={() => toggleImageGenerateType(3)}>
                    <h5>
                      <ArchitectureOutlinedIcon />
                      Diagram
                    </h5>
                    <span>Clear, structured visual explanations.</span>
                  </Link>
                </div>
              </div>
              <div className="custom_prompt">
                <FormControl fullWidth>
                  <TextField
                    id="outlined-basic"
                    label="Custom Prompt"
                    variant="outlined"
                    size="small"
                    placeholder="Type your prompt here "
                    value={imageGeneratePrompt}
                    onChange={(e) => setImageGeneratePrompt(e.target.value)}
                  />
                </FormControl>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleImageGenerate(currentMessageId, currentRequest, currentIndex);
                  }}
                >
                  <span>
                    <AutoFixHighIcon />
                  </span>
                  Generate
                </button>
              </div>
            </div>
          </div>
        </Popover>
        <ShareChat opensharechat={opensharechat} handleClosesharechat={handleClosesharechat} chatId={chatId} />
      </MainPage>
    </>
  );
};
